export const createCookieStorage = ({ name, maxAge = 60 * 60 * 24 * 365, path = '/' }) => ({
	get () {
		if (typeof document === 'undefined') return null
		const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
		return match ? decodeURIComponent(match[2]) : null
	},

	set (value) {
		if (typeof document === 'undefined') return
		document.cookie = `${name}=${encodeURIComponent(value)}; path=${path}; max-age=${maxAge}`
	},
})
